
(function(root, factory) {
    if(typeof exports === 'object') {
        module.exports = factory(require("lodash"), require, exports, module);
    }
    else if(typeof define === 'function' && define.amd) {
        define(["lodash", 'require', 'exports', 'module'], factory);
    }
    else {
        var req = function(id) {return root[id];},
            exp = root,
            mod = {exports: exp};
        factory(_, req, exp, mod);
    }
}(this, function(_, require, exports, module) {
/*
	"object-observe - v0.0.1 - 	2014-10-07" 
*/
// Source: src/util/WeakMap.js
if (typeof WeakMap === 'undefined') {
  (function() {
    var defineProperty = Object.defineProperty;
    var counter = Date.now() % 1e9;

    var WeakMap = function() {
      this.name = '__st' + (Math.random() * 1e9 >>> 0) + (counter++ + '__');
    };

    WeakMap.prototype = {
      set: function(key, value) {
        var entry = key[this.name];
        if (entry && entry[0] === key)
          entry[1] = value;
        else
          defineProperty(key, this.name, {value: [key, value], writable: true});
        return this;
      },
      get: function(key) {
        var entry;
        return (entry = key[this.name]) && entry[0] === key ?
            entry[1] : undefined;
      },
      delete: function(key) {
        var entry = key[this.name];
        if (!entry) return false;
        var hasValue = entry[0] === key;
        entry[0] = entry[1] = undefined;
        return hasValue;
      },
      has: function(key) {
        var entry = key[this.name];
        if (!entry) return false;
        return entry[0] === key;
      }
    };

    if(typeof window !== 'undefined'){
       window.WeakMap = WeakMap;
    }
    if(typeof global !== 'undefined'){
      global.WeakMap = WeakMap;
    }
  })();
}
// Source: src/util/validateArguments.js
 var isCallable = (function(toString){
        var s = toString.call(toString),
            u = typeof u;
        return typeof this.alert === "object" ?
          function isCallable(f){
            return s === toString.call(f) || (!!f && typeof f.toString == u && typeof f.valueOf == u && /^\s*\bfunction\b/.test("" + f));
          }:
          function isCallable(f){
            return s === toString.call(f);
          }
        ;
    })(Object.prototype.toString);

function validateArguments(O, callback, accept){
	if(typeof(O)!=='object'){
	  // Throw Error
	  throw new TypeError("Object.observeObject called on non-object");
	}
	if(isCallable(callback)===false){
	  // Throw Error
	  throw new TypeError("Object.observeObject: Expecting function");
	}
	if(Object.isFrozen(callback)===true){
	  // Throw Error
	  throw new TypeError("Object.observeObject: Expecting unfrozen function");
	}
	if (accept !== undefined) {
	  if (!Array.isArray(accept)) {
	    throw new TypeError("Object.observeObject: Expecting acceptList in the form of an array");
	  }
	}
}
// Source: src/Object.observe.js
if(!Object.observe){
  (function(extend, global){
  	var keys            = [];
  	var performWeakMap  = new WeakMap();
  	var oldValueWeakMap = new WeakMap();
  	var propListWeakMap = new WeakMap();

  	// Notify -------------------------------------start

  	function _Notify(o){
  		this.o = o;
  	}

  	_Notify.prototype.performChange = performChange;

  	_Notify.prototype.notify = notify;

  	//변경이 수행되어도 통지되지 않음.
  	//accept .. ? ..
  	//TODO
  	function performChange(accept, callback, self){
  		puse();
  		_.times(keys.length, checker);
  		callback.apply(self);
  		_.forEach(keys, applyNewData);
  		start();
  	}

  	function notify(notifyObject){
  		var performs;
  		performs = performWeakMap.get(notifyObject.object);
  		_.forEach(performs, function(perform){
  			if( perform.accept.indexOf(notifyObject.type) !== -1){
  				perform.notify.push(notifyObject);
  			}
  		});
  	}

  	// Notify-------------------------------------end

  	function observe(o, callback, accept){
  		initKeys(o, callback);
  		registPerform(o, callback, accept);
  		initOldValue(o);
  		initPropList(o);
  		start();
  	}

  	function registPerform(o, callback, accept){
  		validateArguments(o, callback, accept);
  		accept = (_.isUndefined(accept)) ? ['add', 'update', 'delete', 'reconfigure', 'setPrototype', 'preventExtensions'] : accept;

  		var performs = performWeakMap.get(o);
  		performs.push({
  			callback : callback,
  			accept   : accept,
  			notify   : []
  		});
  	}

  	function unobserve(o, callback){
  		validateArguments(o, callback);
  		
  		if(keys.indexOf(o) === -1){
  			return;
  		}

  		var performs = performWeakMap.get(o);
  		var i, l = performs.length;
  		for(i = 0 ; i < l ; i ++){
  			if( callback === performs[i].callback ){
  				performs.splice(i, 2);
  				l --;
  			}
  		}

  		if(l === 0){
  			deleteObserve(o);
  		}
  	}

  	function deleteObserve(o){
  		if(keys.indexOf(o) !== -1){
  			performWeakMap.delete(o);
  			oldValueWeakMap.delete(o);
  			propListWeakMap.delete(o);
  			_.pull(keys, o);
  		}
  	}

  	function initKeys(o, callback){
  		if(keys.indexOf(o) === -1){
  			performWeakMap.set(o, []);
  			oldValueWeakMap.set(o, {});
  			propListWeakMap.set(o, []);
  			keys.push(o);
  		}
  	}

  	function initOldValue(o){
  		var oldValueObj = {};
  		_.forIn(o, function(val, prop){
  			oldValueObj[prop] = val;
  		});
  		oldValueWeakMap.set(o, oldValueObj);
  	}

  	function initPropList(o){
  		propListWeakMap.set(o, _.keys(o));
  	}

  	var checker = (function(){
  		var noti,
  				propList,
  		 	  newPropList,
  			  oldPropList,
  			  deletePropList,
  			  addPropList,
  			  checkPropList,
  			  updatePropList,
  			  i = -1,
  			  l,
  			  o;

  		function checker(){
  			if( !checkKeys() ){
  				return;
  			}

  			setValues();

  			notifyUpdate();
  			notifyAdd();
  			notifyDelete();

  			applyNewData(o);


  			if(isTail()){
  				i = -1;
  				exec();
  			}	
  		}

  		function checkKeys(){
        if(keys.length === 0){
          puse();
          return false;
        }
        return true;
      }

      function isTail(){
      	return i+1 >= l;
      }

  		function setValues(){
  			l = keys.length;
  			i++;

				o    = keys[i];
				noti = getNotifier(o);

				newPropList = _.keys(o);
				propList = propListWeakMap.get(o);
				oldPropList = oldValueWeakMap.get(o);

  			deletePropList = _.difference(propList, newPropList);
  			addPropList    = _.difference(newPropList, propList);
  			checkPropList  = _.difference(propList, deletePropList);
  			updatePropList = [];
  			_.forEach(checkPropList, function(checkProp){
  				if(oldPropList[checkProp] !== o[checkProp]){
  					updatePropList.push(checkProp);
  				}
  			});
  		}

  		function notifyUpdate(){
  			_.forEach(updatePropList, function(prop){
  				noti.notify({
  					name     : prop,
  					object   : o,
  					type     : 'update',
  					oldValue : oldPropList[prop]
  				});
  			});
  		}

  		function notifyAdd(){
  			_.forEach(addPropList, function(prop){
  				noti.notify({
  					name   : prop,
  					object : o,
  					type   : 'add'
  				});
  			});
  		}

  		function notifyDelete(){
  			_.forEach(deletePropList, function(prop){
  				noti.notify({
  					name     : prop,
  					object   : o,
  					type     : 'delete',
  					oldValue : oldPropList[prop]
  				});
  			});
  		}

  		return checker;
  	})();

  	function applyNewData(o){
  		propListWeakMap.set(o, _.keys(o));
  		initOldValue(o);
  	}

  	var checkerID = -1;
  	function start(){
  		if(checkerID === -1){
  			//checkerID = setImmediate(checker);
        checkerID = setInterval(checker,1);
  		}
  	}

  	function puse(){
  		if(checkerID !== -1){
  			//cleartImmediate(checkerID);
        clearInterval(checkerID);
  			checkerID = -1;
  		}
  	}

  	function deliverChangeRecords(callback){
  		if( !_.isFunction(callback) ){
  			throw new TypeError();
  		}
  		
  		puse();
  		_.times(keys.length, checker);

  		var performs;
  		_.forEach(keys, function(o){
  			performs = performWeakMap.get(o);
  			_.forEach(performs, function(perform){
  				if(	perform.notify.length !== 0	&& perform.callback == callback ){
  					perform.callback(perform.notify);
  					perform.notify = [];
  				}
  			});
  		});

  		start();
  	}

  	function exec(){
  		var performs;
  		_.forEach(keys, function(o){
  			performs = performWeakMap.get(o);
  			_.forEach(performs, function(perform){
  				if(	perform.notify.length !== 0 ){
  					perform.callback.call(undefined, perform.notify);
  					perform.notify = [];
  				}
  			});
  		});
  		performs = null;
  	}

  	function getNotifier(o){
  		return new _Notify(o);
  	}

		extend.observe              = observe;
		extend.unobserve            = unobserve;
		extend.deliverChangeRecords = deliverChangeRecords;
		extend.getNotifier          = getNotifier;

  })(Object, this);
}
return module.exports;
}));
